import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, Button } from '@garnish/core';

/**
 * Cta for starting the order.
 */
export const LoyaltyRewardStartOrderCta = (props: LoyaltyRewardStartOrderCtaProps) => {
  const { isDisabled, palette = 'secondary', onPress } = props;

  const { formatMessage } = useIntl();
  const startOrder = formatMessage(messages.startOrder);

  const ctaTextStyle = palette === 'primary' ? styles.ctaTextWhite : styles.ctaTextDarkKale;

  return (
    <Button
      size="small"
      palette={palette}
      style={styles.cta}
      accessibilityLabel={startOrder}
      disabled={isDisabled}
      onPress={onPress}
    >
      <BodyText style={ctaTextStyle} sizeMatch={['18']}>
        {startOrder}
      </BodyText>
    </Button>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  startOrder: {
    defaultMessage: 'Start order',
    description: 'Loyalty | Reward | Start order CTA',
  },
});

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  cta: {
    alignSelf: 'flex-start',
  },
  ctaTextDarkKale: {
    color: theme.colors.DARK_KALE,
  },
  ctaTextWhite: {
    color: theme.colors.WHITE,
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type LoyaltyRewardStartOrderCtaProps = {
  isDisabled: boolean;
  palette: 'primary' | 'secondary';
  onPress: () => void;
};
